/**
 * Serializes board ops so each request uses the revision confirmed by the previous one.
 * Without this, concurrent move + draw ops race and the later snapshot can drop transforms.
 */
export class OpsQueue {
  private tail: Promise<void> = Promise.resolve();

  enqueue<T>(task: () => Promise<T>): Promise<T> {
    const run = this.tail.then(task, task);
    this.tail = run.then(
      () => undefined,
      () => undefined
    );
    return run;
  }

  reset(): void {
    this.tail = Promise.resolve();
  }
}
